import { cn } from "@/utils/cn";

interface TabButtonProps {
  label: string;
  isActive: boolean;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
}

export default function TabButton({
  label,
  isActive,
  onClick,
  className,
}: TabButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "rounded-t-lg py-3 text-lg! font-semibold font-pretendard px-6 cursor-pointer transition-colors",
        isActive
          ? "text-sig bg-white border-b-4 border-sig"
          : " text-zinc-400 border-b-4 border-transparent ",
        className
      )}
    >
      <h3 className="text-base">{label}</h3>
    </button>
  );
}
